import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import LinkedinFilledSvg from "@ant-design/icons-svg/es/asn/LinkedinFilled";
import AntdIcon from "../components/AntdIcon";
var LinkedinFilled = function LinkedinFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: LinkedinFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  LinkedinFilled.displayName = 'LinkedinFilled';
}
export default /*#__PURE__*/React.forwardRef(LinkedinFilled);